import React, {createContext, useState} from 'react';
import {HashRouter, Redirect, Route, Switch} from 'react-router-dom';
import Login from '../views/login/Login';
import NewsSandBox from '../views/sandbox/NewsSandBox';
import {checkPermission} from '../views/sandbox/common/CheckUserPermission';
import NoPermission from '../views/sandbox/nopermission/NoPermission';
import {menuList} from '../components/configuration/config.json';
import {aesDecrypt} from '../views/sandbox/common/EncodeDecodeMethod';

export const sideMenuContext = createContext();
export default function IndexRouter() {
	const [sideMenu, setSideMenu] = useState([]);
	const [currentItem, setCurrentItem] = useState([]);
	const [editorContent, setEditorContent] = useState('');
	const [openKeys, setOpenKeys] = useState([]);
	const [dataSource, setDataSource] = useState([]);
	const [copyDataSource, setCopyDataSource] = useState([]);
	const [excelData, setExcelData] = useState([]);
	const [fileList, setFileList] = useState([]);
	const [meetingNotice, setMeetingNotice] = useState({});

	return (
		<sideMenuContext.Provider value={{
			sideMenu, setSideMenu, currentItem, setCurrentItem, meetingNotice, setMeetingNotice,
			editorContent, setEditorContent, openKeys, setOpenKeys, fileList, setFileList,
			dataSource, setDataSource, copyDataSource, setCopyDataSource, excelData, setExcelData,
		}}>
			<HashRouter>
				<Switch>
					{/* 配置 login 地址对应的页面 */}
					<Route path="/login" component={Login}/>
					{/* 不用登录直接进入系统页面 */}
					{/* <Route path="/" component={NewsSandBox}/> */}
					{/* 需要验证登录状态才能进入系统页面 */}
					<Route path="/" render={() => {
						if (aesDecrypt(sessionStorage.getItem('shadow'))) {
							if (checkPermission(menuList)) {
								return <NewsSandBox/>;
							} else {
								return <NoPermission/>;
							}
						} else {
							return <Redirect to="/login"/>;
						}
					}}/>
				</Switch>
			</HashRouter>
		</sideMenuContext.Provider>
	);
}
